import { Plus, Minus } from 'lucide-react'

interface Transaction {
  id: number
  action: string
  points: number
  source: string
  created_at: string
}

interface RecentActivityProps {
  transactions: Transaction[]
}

export function RecentActivity({ transactions }: RecentActivityProps) {
  if (transactions.length === 0) {
    return (
      <p className="text-gray-500 text-center py-4">
        Aucune activité récente.
      </p>
    )
  }

  return (
    <div className="space-y-3">
      {transactions.map((transaction) => (
        <div
          key={transaction.id}
          className="flex items-center justify-between py-2 border-b border-gray-100 last:border-0"
        >
          <div className="flex items-center gap-3">
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center ${
                transaction.points > 0
                  ? 'bg-green-100 text-green-600'
                  : 'bg-red-100 text-red-600'
              }`}
            >
              {transaction.points > 0 ? (
                <Plus size={16} />
              ) : (
                <Minus size={16} />
              )}
            </div>
            <div>
              <p className="text-sm font-medium text-gray-900">
                {transaction.action}
              </p>
              <p className="text-xs text-gray-500">
                {formatRelativeDate(transaction.created_at)}
              </p>
            </div>
          </div>
          <span
            className={`text-sm font-semibold ${
              transaction.points > 0 ? 'text-green-600' : 'text-red-600'
            }`}
          >
            {transaction.points > 0 ? '+' : ''}
            {transaction.points} pts
          </span>
        </div>
      ))}
    </div>
  )
}

function formatRelativeDate(dateString: string): string {
  const date = new Date(dateString)
  const now = new Date()
  const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000)

  if (diffInSeconds < 60) {
    return 'À l\'instant'
  }

  const diffInMinutes = Math.floor(diffInSeconds / 60)
  if (diffInMinutes < 60) {
    return `Il y a ${diffInMinutes} min`
  }

  const diffInHours = Math.floor(diffInMinutes / 60)
  if (diffInHours < 24) {
    return `Il y a ${diffInHours}h`
  }

  const diffInDays = Math.floor(diffInHours / 24)
  if (diffInDays < 7) {
    return `Il y a ${diffInDays}j`
  }

  return date.toLocaleDateString('fr-FR')
}
